import common from '@/store/common/mutations';
import * as types from './mutation-types';

import { SEARCH_PARAMS, RTN_PART_INFO, PAGING_INFO } from './state';

export default {
	...common,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.rtnPartMstList = []; //고품회수목록
		state.rptpStList = []; //조회조건 고품상태목록

		state.isMqyStation = false;
	},
	[types.RTN_PART_INFO_INIT]: state => {
		state.rtnPartInfo = RTN_PART_INFO(); //고품회수신청 정보
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.RTN_PART_INFO]: (state, { key, value }) => {
		state.rtnPartInfo[key] = value;
	}
};
